module.exports = __webpack_public_path__ + "img/icon-group5.6dd60b2d.png";